import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

// material-ui
import { Box, List, Typography } from '@mui/material';

// project import
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item, level, accessor, expandedKey, setExpandedKey, sectionConfig = null, index = 0 }) => {
	const menu = useSelector((state) => state.menu);
	const { drawerOpen } = menu;

	const children = useMemo(() => [...(item?.children ?? [])].sort((a, b) => a.serial - b.serial), [item?.children]);
	const hasChildren = children.length > 0;

	if (drawerOpen && sectionConfig && hasChildren) {
		return (
			<Box sx={{ pt: index === 0 ? 0 : 1.5 }}>
				<Typography
					sx={{
						px: 1.5,
						fontSize: '0.625rem',
						fontWeight: 600,
						color: '#94A3B8',
						textTransform: 'uppercase',
						letterSpacing: '0.14em',
					}}
				>
					{sectionConfig.title}
				</Typography>
				<Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
					{children.map((menuItem) => (
						<NavItem
							key={menuItem.id}
							item={menuItem}
							level={1}
							accessor={accessor}
							selectionVariant={sectionConfig.selectionVariant}
							showIcon
						/>
					))}
				</Box>
			</Box>
		);
	}

	if (!drawerOpen && sectionConfig && hasChildren) {
		return (
			<List disablePadding sx={{ mb: 0, py: 0, zIndex: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
				{children.map((menuItem) => (
					<NavItem
						key={menuItem.id}
						item={menuItem}
						level={1}
						accessor={accessor}
						selectionVariant={sectionConfig.selectionVariant}
						showIcon
					/>
				))}
			</List>
		);
	}

	return (
		<List disablePadding sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
			{hasChildren ? (
				<NavCollapse
					item={item}
					level={level}
					accessor={accessor}
					expandedKey={expandedKey}
					setExpandedKey={setExpandedKey}
				/>
			) : (
				<NavItem
					item={item}
					level={level}
					accessor={accessor}
					selectionVariant="brand"
					showIcon
				/>
			)}
		</List>
	);
};

NavGroup.propTypes = {
	item: PropTypes.object,
	level: PropTypes.number,
	accessor: PropTypes.string,
	expandedKey: PropTypes.string,
	setExpandedKey: PropTypes.func,
	sectionConfig: PropTypes.shape({
		title: PropTypes.string,
		selectionVariant: PropTypes.string,
	}),
	index: PropTypes.number,
};

export default NavGroup;
